import React from "react";
import styled, { css } from "styled-components";
import { TextLink } from "../../SharableStyles/FormStyle";
import { Link } from "react-router-dom";
import { link } from "ionicons/icons";

const Message = styled.div`
  justify-content: center;
  align-items: center;

  border-radius: 10px;
  .message {
    padding: 1.2rem 2.4rem;
    text-align: center;
  }

  .message,
  .link {
    font-size: 1.2rem !important;
    display: inline-block;
  }

  .message:first-letter {
    text-transform: capitalize;
  }

  ${({ type }) =>
    type === "error"
      ? css`
          border: 1px solid #b91c1c;
          background-color: #fee2e2;
        `
      : type === "success" &&
        css`
          border: 1px solid #80ff80;
          background-color: #bfffbf;
        `}

  ${({ backgroundColor }) =>
    backgroundColor === "transparent" &&
    css`
      color: #b91c1c;
      background-color: transparent;
      border: none;
      .message {
        padding: 0.4rem;
      }
    `}

  ${({ align }) =>
    align === "left" &&
    css`
      justify-content: start;
    `}
`;
export default function FormMessage({
  type = "error",
  message,
  backgroundColor,
  align,
  textLink,
  linkTo,
}) {
  return (
    <Message
      className="flex justify-center"
      backgroundColor={backgroundColor}
      align={align}
      type={type}
    >
      {backgroundColor === "transparent" && "*"}
      <p className="message">
        {message}{" "}
        {textLink && (
          <TextLink className="link">
            <Link to={linkTo}>{textLink}.</Link>
          </TextLink>
        )}
      </p>{" "}
    </Message>
  );
}
